import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";

// --- Styled Components ---

const ProfileSection = styled.section`
  padding: 10px 20px; /* reduced spacing */
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px 40px; /* reduced gaps */

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionTitle = styled.h2`
  font-size: 2.1rem; /* increased font */
  color: #439E6D;
  text-transform: uppercase;
  font-weight: 700;
  // margin-bottom: 18px; /* reduced spacing */
  border-bottom: 2px solid #eee;
  padding-bottom: 8px;
  display: inline-block;
`;

const Paragraph = styled.p`
  font-size: 1.15rem; /* increased font */
  line-height: 1.8;
  margin-bottom: 15px; /* reduced spacing */
  text-align: justify;
  color: #444;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  font-size: 1.1rem; /* increased font */
  line-height: 1.8;
  margin-bottom: 12px; /* reduced spacing */
  display: flex;
  align-items: flex-start;

  &::before {
    content: "•";
    color: #1a2b49;
    font-weight: bold;
    margin-right: 10px;
  }
`;

const NumberedList = styled.ol`
  padding-left: 20px;
  margin: 0;
`;

const NumberedItem = styled.li`
  font-size: 1.1rem; /* increased font */
  line-height: 1.8;
  margin-bottom: 12px; /* reduced spacing */
  color: #444;
  padding-left: 8px;
`;

// --- Component ---

const CorporateProfile = () => {
  return (
    <ProfileSection>
      <ContentGrid>
        
        {/* Left Column: Profile & Quality Objectives */}
        <Column>
          <Fade direction="left" triggerOnce>
            <SectionTitle>Our Corporate Profile</SectionTitle>

            <Paragraph>
              Padec Global Services Limited (PGSL), established in December 2004 is an indigenous firm to offer Consultancy and contract services to Oil gas Companies, various tiers of Government, Corporate bodies, Industries and Individual Clients in Surveying, Civil Engineering and general procurement.
            </Paragraph>

            <Paragraph>
              It provides integrated client focused and cost effective services in the oil and gas industry with specialized expertise for both onshore and offshore operations.
            </Paragraph>

            <Paragraph>
              PGSL has assembled a highly qualified team of professionals with worldwide experience and capability to provide practical solutions to complex problems at all phases of Surveying and Civil Engineering.
            </Paragraph>

            <SectionTitle style={{ marginTop: '25px' }}>
              Our Quality Objectives
            </SectionTitle>

            <NumberedList>
              <NumberedItem>
                In consonance with PADEC Core Values, and Quality Policy Statement, top management ensures that the following Corporate Quality Objectives directed at relevant functions and levels in the company are pursued.
              </NumberedItem>

              <NumberedItem>
                Ensuring there is clear understanding of client's requirements in each contract/project to enable timely and satisfactory service delivery that meet the needs and exceed the expectations of clients.
              </NumberedItem>

              <NumberedItem>
                Provision of adequate resources and ensuring work is carried out to defined policies, procedures and instructions with an emphasis on continual process improvement.
              </NumberedItem>
            </NumberedList>
          </Fade>
        </Column>

        {/* Right Column: Objectives & Values */}
        <Column>
          <Fade direction="right" triggerOnce>
            <SectionTitle>Our Corporate Objectives</SectionTitle>

            <List>
              <ListItem>
                To improve on our areas of strength and core competencies by enhancing the skills and professionalism of our staff through continued training and motivation.
              </ListItem>

              <ListItem>
                To strengthen our relationship with our clients by way of effective interface in project execution with attention paid to client feedback.
              </ListItem>

              <ListItem>
                To explore new global market for corporate expansion and utilization of developed opportunities in emerging regional markets.
              </ListItem>
            </List>

            <SectionTitle style={{ marginTop: '25px' }}>
              Our Values
            </SectionTitle>

            <Paragraph>
              At PGSL, we believe in creating and providing solutions. We feel that every man-hour spent should make you money and give satisfaction.
            </Paragraph>

            <Paragraph>
              We focus on results. To do that, we believe in hiring – and keeping – good people, people who strive not just to do a good job, but also to do what’s right, ethical and good for our clients.
            </Paragraph>

            <SectionTitle style={{ marginTop: '25px' }}>
              Our General Business Principles
            </SectionTitle>

            <NumberedList>
              <NumberedItem>
                Recognition as a company that gives equal opportunity to all Nigerians from all States of the Federation, with due regard given to excellence and merit.
              </NumberedItem>

              <NumberedItem>
                Recognition as a company that can be relied upon and that provides good services.
              </NumberedItem>
            </NumberedList>
          </Fade>
        </Column>

      </ContentGrid>
    </ProfileSection>
  );
};

export default CorporateProfile;